import React from 'react';

import { Avatar, Button, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { usePetitionDetailsPageData } from 'src/app/pages/petitionDetails/pageContext';

import { usePetitionStarterMediaInquiry } from '../../hooks/petitionStarterMediaInquiry';
import { usePetitionStarterPhoto } from '../../hooks/petitionStarterPhoto';
import { CommunityPetitionLink } from '../CommunityPetitionLink';

import { StarterLink } from './components/StarterLink';

export const PetitionStarter: React.FC = () => {
	const {
		data: {
			petition: { id, organization, user, isCommunityPetition },
		},
	} = usePetitionDetailsPageData();
	const { photoUrl } = usePetitionStarterPhoto();
	const {
		data: { enabled, url },
		actions: { handleMediaInquiryClick },
	} = usePetitionStarterMediaInquiry(id);
	const AVATAR_SIZE = 56;

	if (isCommunityPetition) {
		return <CommunityPetitionLink data-qa="community-petition-link" />;
	}

	return (
		<div
			className="mt-6 mt-20 mb-4 flex flex-col flex-nowrap items-start justify-between gap-4 gap-[20px] self-stretch border-t border-t-gray-200 pt-6 md:mt-20 md:flex-row"
			data-testid="petition-starters-section"
			data-qa="petition-starter-section"
		>
			<div className="flex gap-3">
				<Avatar size={AVATAR_SIZE} alt="avatar of the starter" src={photoUrl} />
				<div className="flex flex-1 flex-col items-start gap-2">
					<div className="flex flex-col">
						<StarterLink user={user} organization={organization} />
						<Text
							variant="body"
							size="medium"
							fontWeight="light"
							className="text-typography-weak mb-1"
							data-testid="petition-starter-text"
						>
							<Translate value="corgi.petition_gamma.details.starter_text" />
						</Text>
						{user.description && (
							<Text variant="body" expressive data-testid="petition-starter-description" className="leading-[28px]">
								{user.description}
							</Text>
						)}
					</div>
				</div>
			</div>

			{enabled && (
				<div className="min-w-[131px] pl-[68px] md:pl-0">
					<Button
						as="a"
						href={url}
						variant="secondary"
						size="x-small"
						data-testid="media-inquiry"
						data-qa="media-inquiry"
						onClick={handleMediaInquiryClick}
					>
						<Translate value="corgi.petition_gamma.petition_starter.add_media_inquiries.action" />
					</Button>
				</div>
			)}
		</div>
	);
};
